import Box from "@mui/material/Box";

import { FooterPublicRoutes } from "../footer";
import { Header } from "./Header";
import { SideMenuAdmin } from "../RevampedSidebar";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectProfile } from "../../store/profile/selector";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";

export function LayoutPublicRoute({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) {
  const profile = useSelector(selectProfile);
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Header />
      {!profile ? (
        <Box className="w-full mt-16">
          {children}
          <FooterPublicRoutes />
        </Box>
      ) : (
        <Box className="flex w-screen mt-16">
          <SideMenuAdmin adminMenu />
          <Box className="min-w-[calc(100vw-240px)] h-[calc(100vh-64px)] w-full overflow-auto">
            {children}
            <FooterPublicRoutes />
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default LayoutPublicRoute;
